import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const DashboardLanding = () => {
  const { user } = useAuth();
  const role = typeof user?.role === 'string' ? user.role.toLowerCase() : '';

  if (role === 'employee') {
    return <Navigate to="/employee-self-service" replace />;
  }

  if (role === 'manager' || role === 'admin') {
    return <Navigate to="/manager-self-service" replace />;
  }

  return <Navigate to="/employee-scheduling" replace />;
};

export default DashboardLanding;
